var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0286255 22.1008C0.0286255 20.9962 0.924056 20.1008 2.02863 20.1008H26.5121C27.6167 20.1008 28.5121 20.9962 28.5121 22.1008C28.5121 23.2054 27.6167 24.1008 26.5121 24.1008H2.02863C0.924056 24.1008 0.0286255 23.2054 0.0286255 22.1008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0286255 12.0787C0.0286255 10.9741 0.924056 10.0787 2.02863 10.0787H26.5121C27.6167 10.0787 28.5121 10.9741 28.5121 12.0787C28.5121 13.1833 27.6167 14.0787 26.5121 14.0787H2.02863C0.924056 14.0787 0.0286255 13.1833 0.0286255 12.0787Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0286255 2.05663C0.0286255 0.952056 0.924056 0.0566254 2.02863 0.0566254H26.5121C27.6167 0.0566254 28.5121 0.952056 28.5121 2.05663C28.5121 3.16119 27.6167 4.05663 26.5121 4.05663H2.02863C0.924056 4.05663 0.0286255 3.16119 0.0286255 2.05663Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export default ForwardRef;